// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"9bb20397","159":"6954fd82","254":"64375d43","352":"af22f956","473":"c9a46b80","601":"9d33e81b","614":"57e60a28","627":"78bfbe63","787":"10a6e26a","868":"9cd47cdc","904":"fbdfccaa"}[chunkId] + ".chunk.js";
};